import {
  createContext,
  ReactNode,
  useContext,
  useReducer,
  useRef
} from "react";
import { createPortal } from "react-dom";

import {
  initialTopbarState,
  topbarReducer,
  TopbarVisibilityState
} from "../hooks/useTopbarReducer";
import { TopbarDispatchContext } from "./TopbarDispatchProvider";
import styles from "./TopBars.module.scss";

type Props = {
  children: ReactNode;
};

const TopbarContext = createContext<{
  ref?: {
    current: HTMLDivElement | null | undefined;
  };
  topbarsVisibility: TopbarVisibilityState;
}>({ topbarsVisibility: { ...initialTopbarState } });

export function TopbarPortal({ children }: { children: React.ReactNode }) {
  const { ref } = useContext(TopbarContext);

  return ref && ref.current && children
    ? createPortal(children, ref.current)
    : null;
}

export function useTopbarContext() {
  return useContext(TopbarContext);
}

export default function TopBarProvider({ children }: Props) {
  const ref = useRef<HTMLDivElement | null | undefined>(null);
  const [topbarsVisibility, dispatch] = useReducer(
    topbarReducer,
    initialTopbarState
  );

  return (
    <TopbarContext.Provider
      value={{
        ref,
        topbarsVisibility
      }}
    >
      <TopbarDispatchContext.Provider value={dispatch}>
        <div className={styles.wrapper}>
          {children}

          {/* Render top bar after children, so they appear "over" other elements: */}
          {/* @ts-ignore */}
          <div ref={ref} className={styles.topBar} data-test="Topbar" />
        </div>
      </TopbarDispatchContext.Provider>
    </TopbarContext.Provider>
  );
}
